import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef } from 'react';
import { ContextMenuItem as RadixContextMenuItem } from '@radix-ui/react-context-menu';
import { BaseDropdownItemUI } from '../base/BaseDropdownItemUI';
export const ContextMenuItem = forwardRef<ComponentRef<typeof RadixContextMenuItem>, Omit<ComponentPropsWithoutRef<typeof RadixContextMenuItem>, 'asChild'> & {
  checked?: boolean;
  invalid?: boolean;
}>((props, ref) => {
  const {
    className,
    checked,
    disabled,
    invalid,
    children,
    ...rest
  } = props;
  return <RadixContextMenuItem {...rest} ref={ref} asChild={true}>
      <BaseDropdownItemUI className={className} checked={checked || false} disabled={disabled || false} invalid={invalid || false}>
        {children}
      </BaseDropdownItemUI>
    </RadixContextMenuItem>;
});
ContextMenuItem.displayName = RadixContextMenuItem.displayName;